import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {
  expandFadeInFromLeftAnimation,
  fadeOutToLeftCollapseAnimation,
} from '../../../../../../shared/animations/index';
import { IconButtonIconTypes } from '../../../../constants/icon-button-icon-types.constant';
import { TableListItemActionsBlockLocations } from '../../../../constants/table-list-item-actions-block-locations.constant';

@Component({
  selector: 'table-list-item',
  standalone: false,
  templateUrl: './table-list-item.component.html',
  styleUrls: ['./table-list-item.component.scss'],
  animations: [
    trigger('expandFadeInFromLeftFadeOutToLeftCollapseAnimation', [
      transition(':enter', [
        useAnimation(expandFadeInFromLeftAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToLeftCollapseAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class TableListItemComponent {
  @HostBinding('@expandFadeInFromLeftFadeOutToLeftCollapseAnimation') true;

  @Input('id') itemId: string;
  @Input() actionsBlockLocation: TableListItemActionsBlockLocations =
    TableListItemActionsBlockLocations.Right;
  @Input() allowRemove: boolean;

  @Output('remove') removeEvent: EventEmitter<string> =
    new EventEmitter<string>();

  get displayActionsBlock() {
    return this.allowRemove;
  }

  iconButtonIconTypes = IconButtonIconTypes;

  handleRemoveItemAction() {
    this.remove();
  }

  remove() {
    this.removeEvent.emit(this.itemId);
  }
}
